export default function () {
  return [

    {
      key: 'id',
      label: 'account'
    },
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'name',
      label: 'clientName'
    },
    {
      key: 'email',
      label: 'clientEmail'
    },

    {
      key: 'representativeUserIds',
      type: 'user',
      props: {
        clearable: true,
        multiple: true,
        nullable: true
      },
      permissions: ['CLIENT_READ_ALL']
    },
    {
      key: 'buTypes',
      label: 'departments',
      type: 'department',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      type: 'checkboxGroup',
      fields: [
     /*    {
          key: 'active',
          label: 'active',
          type: 'checkbox'
        }, */
        {
          key: 'isDemo',
          label: 'demo',
          type: 'checkbox'
        },
        {
          key: 'marginCall',
          label: 'marginCall',
          type: 'checkbox'
        }
      ]
    }
  ];
}
